// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL_admin}/log`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');
    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const logHistoryApi = createApi({
  reducerPath: 'logHistoryApi',
  baseQuery,
  endpoints: (builder) => ({
    getLogHistory: builder.query({
      query: (q) =>
        `/?startDate=${q.startDate}&endDate=${q.endDate}&logType=${q.type}&size=${q.size}&page=${q.page}&sorgcode=${q.sorgcode}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLazyGetLogHistoryQuery } = logHistoryApi;
